export default "__VITE_ASSET__udl6lq_M__"